import { createApi } from "@reduxjs/toolkit/query/react";
import {
  Trait,
  TraitsDropdown,
} from "@src/pages/super-admin/traits/Traits.types";
import { APIResponse, PaginationType } from "@src/types/CommonTypes";
import { baseQueryWithReauth } from "@src/utils/baseQuery";

interface GetAllTraitsResponse extends APIResponse {
  response: { content: Trait[] } & PaginationType;
}

interface AddUpdateTraitResponse extends APIResponse {
  response: Trait;
}

interface GetActiveTraitsForDropdownResponse extends APIResponse {
  response: TraitsDropdown[];
}

export const TraitsApiSlice = createApi({
  reducerPath: "traitsApiSlice",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getAllTraits: builder.query<
      GetAllTraitsResponse,
      { pageNo: number; pageSize: number }
    >({
      query: ({ pageNo, pageSize }) => ({
        url: `trait/get-all?pageNo=${pageNo}&pageSize=${pageSize}`,
        method: "GET",
      }),
    }),
    addTrait: builder.mutation<AddUpdateTraitResponse, Partial<Trait>>({
      query: (traitData) => ({
        url: `trait`,
        method: "POST",
        body: traitData,
      }),
    }),
    updateTrait: builder.mutation<
      AddUpdateTraitResponse,
      { traitId: string; traitData: Partial<Trait> }
    >({
      query: ({ traitId, traitData }) => ({
        url: `trait?traitId=${traitId}`,
        method: "PUT",
        body: traitData,
      }),
    }),
    deleteTrait: builder.mutation<APIResponse, { traitId: string }>({
      query: ({ traitId }) => ({
        url: `trait?traitId=${traitId}`,
        method: "DELETE",
      }),
    }),
    getActiveTraitsForDropDown: builder.query<
      GetActiveTraitsForDropdownResponse,
      void
    >({
      query: () => ({
        url: `trait/get-traits-dropdown`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useLazyGetAllTraitsQuery,
  useAddTraitMutation,
  useUpdateTraitMutation,
  useDeleteTraitMutation,
  useGetActiveTraitsForDropDownQuery,
  useLazyGetActiveTraitsForDropDownQuery
} = TraitsApiSlice;
